import { Popup } from './models';

const popup: Popup = {
    content: '',
    isOpened: false
}

export default popup